import { RecentlyViewed } from '@theme/recently-viewed-products';
import { sectionRenderer } from '@theme/section-renderer';

class DrawerRecentlyViewed extends HTMLElement {
  #details;

  connectedCallback() {
    this.#details = this.closest('details');
    this.#details?.addEventListener('toggle', this.#handleToggle);

    if (this.#details?.open) this.#load();
  }

  disconnectedCallback() {
    this.#details?.removeEventListener('toggle', this.#handleToggle);
  }

  #handleToggle = () => {
    if (this.#details?.open) this.#load();
  };

  async #load() {
    const list = this.querySelector('[data-recently-viewed-list]');
    if (!(list instanceof HTMLElement)) return;

    let viewedProducts = [];
    try {
      viewedProducts = RecentlyViewed.getProducts();
    } catch (_error) {
      viewedProducts = [];
    }

    const currentProductId = this.dataset.currentProductId;
    viewedProducts = viewedProducts.filter((id) => String(id) !== currentProductId).slice(0, 4);

    if (viewedProducts.length === 0) {
      list.replaceChildren();
      this.hidden = true;
      return;
    }

    const url = new URL(Theme.routes.search_url, location.origin);
    url.searchParams.set('q', viewedProducts.map((id) => `id:${id}`).join(' OR '));
    url.searchParams.set('resources[type]', 'product');

    try {
      const markup = await sectionRenderer.getSectionHTML('predictive-search', false, url);
      const parsed = new DOMParser().parseFromString(markup, 'text/html');
      const sourceItems = parsed.querySelectorAll('#predictive-search-products li');
      const items = [];

      for (const sourceItem of sourceItems) {
        const card = sourceItem.querySelector('.resource-card');
        const link = card?.querySelector('a[href*="/products/"]');
        if (!(card instanceof HTMLElement) || !(link instanceof HTMLAnchorElement)) continue;

        const item = document.createElement('li');
        item.className = 'menu-drawer__featured-content-list-item menu-drawer__featured-content-list-item--product';
        item.append(card.cloneNode(true));
        items.push(item);
      }

      list.replaceChildren(...items);
      this.hidden = items.length === 0;
    } catch (_error) {
      list.replaceChildren();
      this.hidden = true;
    }
  }
}

if (!customElements.get('drawer-recently-viewed')) {
  customElements.define('drawer-recently-viewed', DrawerRecentlyViewed);
}
